import {BoosterDto, SumType} from "@/store/shop/types";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import BoosterUtils from "@/utils/booster-utils";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import {Tr} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";

export class ShopBoosterPanel extends Phaser.GameObjects.Container {

    public static HEIGHT = 180;

    constructor(scene: Phaser.Scene, x: number, y: number, b: BoosterDto, callback: () => void) {
        super(scene);

        this.scene = scene;
        this.x = x;
        this.y = y;
        this.width = CU.CANVAS_WIDTH;
        this.height = ShopBoosterPanel.HEIGHT;

        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);

        const image = SpriteUtils.addImage(this.scene, 70, ShopBoosterPanel.HEIGHT / 2 - 5, Keys.ATLAS_BOOST, BoosterUtils.getIcon(b.boosterType), 0.9);

        const titleLight = SpriteUtils.addImage(this.scene, 140 - b.name.length * 5, 5 + this.getTitleShift(), Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_LIGHT)
            .setOrigin(0, 0);
        SpriteUtils.setDispSize(titleLight, 240 / 11.5 * b.name.length * CU.S, 65 * CU.S);

        let titleText = TextUtils.addTextAdvanced(scene, b.name, 140, 40 + this.getTitleShift(),
            '#eec761', 15, 'normal', 350, 'left', 2, Fonts.BENGALY_NORMAL);
        titleText.setStroke('#000000', 1);

        // let descText = TextUtils.addTextAdvanced(scene, b.desc.toUpperCase(), 140, titleText.y / CU.S + 50,
        //     '#d7d7d7', 12, 'normal', 300, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let descText = new BBCodeText(scene, 140 * CU.S, titleText.y + 25 * CU.S, b.desc.toUpperCase(), {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '12pt',
            shadow: {
                offsetX: -1,
                offsetY: 2,
                color: '#000000'
            },
            stroke: '#000000',
            align: 'left',
            wrap: {
                mode: 1,
                width: 290
            }
        }).setOrigin(0, 0).setScale(CU.S, CU.S);

        let buyButton = SpriteUtils.scale(new SquareButton(this.scene, 515, 85, 0, Keys.UI_ART_GREEN_BUTTON,
            undefined, this.getButtonIcon(), this.getButtonText(b.sumType), false), 0.8 / CU.S)
            .setAlpha(b.sumType === SumType.UNAVAILABLE ? 0.25 : 1.0);

        buyButton.setCallback(() => {
            callback();
        });

        const separator = SpriteUtils.addSprite(this.scene!, 0, ShopBoosterPanel.HEIGHT, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0, 1);

        this.add([back, image, titleLight, titleText, descText, buyButton, separator]);

        let buyPriceText;
        if (b.initialPrice === b.finalPrice || b.sumType === SumType.UNAVAILABLE) {
            buyPriceText = TextUtils.addText(scene,
                String(b.sumType === SumType.UNAVAILABLE ? b.initialPrice : b.finalPrice), 515, 118, '#ffffff', 18, 'bold', 200)
                .setAlpha(b.sumType === SumType.UNAVAILABLE ? 0.25 : 1.0);
        } else {
            buyPriceText = TextUtils.addTextAdvanced(scene, String(b.finalPrice), 515, 118,
                '#0cff00', 19, 'normal', 200, 'center', 2, Fonts.MYRIADPRO_BOLD);

            buyPriceText.setShadow(0, 0, '#ffffff');
            buyPriceText.setStroke('#000000', 2);
        }
        this.add(buyPriceText);

        if (b.initialPrice !== b.finalPrice && b.sumType !== SumType.UNAVAILABLE) {
            let oldPriceText = TextUtils.addTextAdvanced(scene, String(b.initialPrice), 515, 95,
                '#ffffff', 13, 'normal', 200, 'center', 2, Fonts.MYRIADPRO_REGULAR);
            oldPriceText.setShadow(0, 0, '#ffffff');
            oldPriceText.setStroke('#000000', 2);

            let underline = scene.add.line(0, 0,
                oldPriceText.getLeftCenter().x! + 14 * CU.S, oldPriceText.getLeftCenter().y!,
                oldPriceText.getRightCenter().x! + 14 * CU.S, oldPriceText.getRightCenter().y! + 14 * CU.S, 0xFF0000, 1);

            this.add([oldPriceText, underline]);
        }

        if (b.validTill && b.validTill.length > 0) {
            let activeText = TextUtils.addTextAdvanced(scene, Tr('act.till') + b.validTill, 140, descText.getBottomCenter().y / CU.S + 5,
                '#78ff46', 13, 'bold', 320, 'left', 1, Fonts.MYRIADPRO_REGULAR);
            activeText.setOrigin(0, 0);
            this.add(activeText);
        }
    }

    protected getTitleShift(): number {
        return 0;
    }

    protected getDescriptionShift(): number {
        return 25;
    }

    protected getButtonIcon(): string {
        return Keys.IC_100_MITHRIL;
    }

    protected getButtonText(sumType: SumType): string {
        switch (sumType) {
            case SumType.BUY:
                return Tr('kupit');
            case SumType.REPLACE:
                return Tr('repl');
            case SumType.UNAVAILABLE:
                return '';
            case SumType.APPEND:
                return Tr('append');
        }
        return '';
    }

}
